namespace Matrix.Rebalancer {
    export class ModellingViewColumns {
        static columnsKey = 'Rebalancer.ModellingView';
    }
}
